/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * メディアリスト選択設定(1:手動選択/2:自動選択)
 * @export
 * @enum {string}
 */
export enum ReleaseSendTargetType {
    MANUAL = 1,
    AUTO = 2
}

export function ReleaseSendTargetTypeFromJSON(json: any): ReleaseSendTargetType {
    return ReleaseSendTargetTypeFromJSONTyped(json, false);
}

export function ReleaseSendTargetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseSendTargetType {
    return json as ReleaseSendTargetType;
}

export function ReleaseSendTargetTypeToJSON(value?: ReleaseSendTargetType | null): any {
    return value as any;
}

